import React, { useState, useEffect } from "react";
import Numeral from "numeral";
import { some } from "lodash-es";
import { useRouter } from "next/router";

import { useTranslation } from "next-i18next";
import SelectEbox from "ab-select-e-box";
import Button from "ab-form-button";
import { registerLocale } from "ab-functions";
import { useEboxContext } from "ab-context-ebox";
import { useCartContext } from "ab-context-cart";

import "./ab-modal-upselling.scss";

const ModalUpselling = ({
  showModal,
  setShowModal,
  products,
  product,
  i18n,
}) => {
  const [selected, setSelected] = useState();
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation("common", { i18n });
  const router = useRouter();

  const [stateEbox, dispatchEbox] = useEboxContext();
  const { itemsEbox, giftMsg, giftName, giftLastName } = stateEbox;
  const { addItemsToEbox, resetEbox } = dispatchEbox;
  const [state, dispatch] = useCartContext();
  const { addItemToCart } = dispatch;
  useEffect(() => {
    registerLocale();
  }, []);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "initial";
    }
    registerLocale();
  }, [showModal]);

  let tempPrice = 0;
  let tempPriceToShow = Numeral(0).value();
  // console.log("estuchePrice", tempPriceToShow);
  itemsEbox?.map((itm) => {
    tempPrice += Numeral(itm?.price).value();
    tempPriceToShow += Numeral(itm?.price).value();
    // console.log("estuchePrice", tempPriceToShow, itm);
  });
  console.log("ModalUpselling", products, itemsEbox);

  return (
    <>
      <div
        className={`modal-upselling-background ${showModal ? "show" : ""}`}
      />
      <div
        className={`modal-upselling ${showModal ? "show" : ""}`}
        id={"modal-container"}
        onClick={(e) => {
          setShowModal(false);
          document.body.style.overflow = "initial";
        }}
        role="button"
        tabIndex="0"
      >
        <div
          className={"content"}
          onClick={(e) => {
            // console.log("ModalContent onclick");
            e.stopPropagation();
          }}
        >
          <button
            className="close"
            onClick={(e) => {
              setShowModal(false);
              document.body.style.overflow = "initial";
              e.stopPropagation();
            }}
          >
            +
          </button>

          <SelectEbox
            title={product?.name || 'Experience Box '}
            contenidodebajo={product?.description}
            subtitle={t('que-incluye-ebox')}
            tipo={'Experiencias'}
            products={products}
            classname={"white upselling"}
            upsellingModal
          />

          <Button
            loading={loading}
            disabled={
              some(itemsEbox, (ebox) => !ebox?.sku) || !itemsEbox?.length
            }
            onClick={async () => {
              let addons = [];
              setLoading(true);

              addons.push({
                display: `${Numeral(tempPrice).format("1,000.00")}&euro;`,
                name: "Ebox - Price",
                price: tempPrice,
                value: tempPrice,
              });

              if (giftMsg) {
                addons.push({
                  name: "Dedicatoria Experience Box",
                  price: "0",
                  value: giftMsg,
                });
              }

              if (giftName && giftLastName) {
                addons.push({
                  name: "Beneficiario",
                  price: "0",
                  value: giftName + " " + giftLastName,
                });
              }

              addons.push({
                name: "Experiencias",
                price: "",
                value: itemsEbox.map((itm) => itm.sku).join(),
              });
              addons.push({
                name: "Que incluye",
                price: "",
                value: itemsEbox.map((itm) => itm?.name).join(),
              });

              let extraData = {
                addons,
              };

              await addItemToCart(
                { databaseId: product?.databaseId, price: tempPriceToShow },
                1,
                null,
                JSON.stringify(extraData)
              );
              router.push(t("/cesta"));
              setTimeout(() => {
                setShowModal(false);
              }, 1500);
              resetEbox();
              document.body.style.overflow = "initial";
            }}
          >
            {t("continue")}
          </Button>

          <span className="footer">{t('notaInfoFecha')}</span>
        </div >
      </div >
    </>
  );
};

export default ModalUpselling;
